import React from 'react'
import styled from 'styled-components'
import TextAreaInput from '@components/Form/TextAreaInput'
import TextInput from '@components/Form/TextInput'
import {
    PageSubTitle,
    FormWrapper,
    FormRow,
    SubmitBtn,
    FormSection,
    GrayWrapper,
    FormSectionTitle,
} from '@appearance/styled'

export default ({
    show,
    newAppConfig,
    setNewAppConfigProp,
    openSaveConfigsModal,
}) => {
    if (!show) {
        return null
    }

    return (
        <GrayWrapper>
            <FormWrapper>
                <PageSubTitle>עריכת אימיילים</PageSubTitle>

                <FormSection>
                    <FormRow>
                        <FormSectionTitle>
                            רשימת אימיילים לצור קשר
                        </FormSectionTitle>
                    </FormRow>
                    <FormRow>
                        <TextInput
                            text={
                                newAppConfig ? newAppConfig.contact_us_list : ''
                            }
                            onChangeText={(contact_us_list) => {
                                setNewAppConfigProp({
                                    contact_us_list: contact_us_list.replace(
                                        ' ',
                                        ''
                                    ),
                                })
                            }}
                            width={'initial'}
                            required={true}
                            label={'הפרד רשימה על ידי פסיקים בלבד (ללא רווחים)'}
                            hideRequiredSign
                        />
                    </FormRow>
                </FormSection>

                <FormSection>
                    <FormRow>
                        <FormSectionTitle>
                            הודעה למשתמש על תשלום דמי חברות
                        </FormSectionTitle>
                    </FormRow>
                    <FormRow>
                        <TextInput
                            text={
                                newAppConfig
                                    ? newAppConfig.payment_recieved_subject
                                    : ''
                            }
                            onChangeText={(payment_recieved_subject) =>
                                setNewAppConfigProp({
                                    payment_recieved_subject,
                                })
                            }
                            width={'initial'}
                            required={true}
                            label={'נושא ההודעה'}
                            hideRequiredSign
                        />
                    </FormRow>
                    <FormRow>
                        <TextAreaInput
                            text={
                                newAppConfig
                                    ? newAppConfig.payment_recieved_body
                                    : ''
                            }
                            onChangeText={(payment_recieved_body) =>
                                setNewAppConfigProp({
                                    payment_recieved_body,
                                })
                            }
                            minHeight="200px"
                            placeholder="הקלד כאן"
                            label={'תוכן ההודעה'}
                        />
                    </FormRow>
                </FormSection>

                <FormSection>
                    <FormRow>
                        <FormSectionTitle>
                            הודעה למשתמש על סימון אי תשלום דמי חברות
                        </FormSectionTitle>
                    </FormRow>
                    <FormRow>
                        <TextInput
                            text={
                                newAppConfig
                                    ? newAppConfig.payment_reminder_subject
                                    : ''
                            }
                            onChangeText={(payment_reminder_subject) =>
                                setNewAppConfigProp({
                                    payment_reminder_subject,
                                })
                            }
                            width={'initial'}
                            required={true}
                            label={'נושא ההודעה'}
                            hideRequiredSign
                        />
                    </FormRow>
                    <FormRow>
                        <TextAreaInput
                            text={
                                newAppConfig
                                    ? newAppConfig.payment_reminder_body
                                    : ''
                            }
                            onChangeText={(payment_reminder_body) =>
                                setNewAppConfigProp({
                                    payment_reminder_body,
                                })
                            }
                            minHeight="200px"
                            placeholder="הקלד כאן"
                            label={'תוכן ההודעה'}
                        />
                    </FormRow>
                </FormSection>

                <FormSection>
                    <FormRow>
                        <FormSectionTitle>
                            הודעה למשתמש על ריקוד מאושר (אישור הזמנה) על ידי
                            ההנהלה
                        </FormSectionTitle>
                    </FormRow>
                    <FormRow>
                        <TextInput
                            text={
                                newAppConfig
                                    ? newAppConfig.approved_application_mail_subject
                                    : ''
                            }
                            onChangeText={(approved_application_mail_subject) =>
                                setNewAppConfigProp({
                                    approved_application_mail_subject,
                                })
                            }
                            width={'initial'}
                            required={true}
                            label={'נושא ההודעה'}
                            hideRequiredSign
                        />
                    </FormRow>
                    <FormRow>
                        <TextAreaInput
                            text={
                                newAppConfig
                                    ? newAppConfig.approved_application_mail_body
                                    : ''
                            }
                            onChangeText={(approved_application_mail_body) =>
                                setNewAppConfigProp({
                                    approved_application_mail_body,
                                })
                            }
                            minHeight="200px"
                            placeholder="הקלד כאן"
                            label={'תוכן ההודעה'}
                        />
                    </FormRow>
                </FormSection>

                <FormSection>
                    <FormRow>
                        <FormSectionTitle>
                            הודעה למשתמש על הפיכת ריקוד לריקוד קיים על ידי
                            ההנהלה
                        </FormSectionTitle>
                    </FormRow>
                    <FormRow>
                        <TextInput
                            text={
                                newAppConfig
                                    ? newAppConfig.completed_application_mail_subject
                                    : ''
                            }
                            onChangeText={(
                                completed_application_mail_subject
                            ) =>
                                setNewAppConfigProp({
                                    completed_application_mail_subject,
                                })
                            }
                            width={'initial'}
                            required={true}
                            label={'נושא ההודעה'}
                            hideRequiredSign
                        />
                    </FormRow>
                    <FormRow>
                        <TextAreaInput
                            text={
                                newAppConfig
                                    ? newAppConfig.completed_application_mail_body
                                    : ''
                            }
                            onChangeText={(completed_application_mail_body) =>
                                setNewAppConfigProp({
                                    completed_application_mail_body,
                                })
                            }
                            minHeight="200px"
                            placeholder="הקלד כאן"
                            label={'תוכן ההודעה'}
                        />
                    </FormRow>
                </FormSection>

                <FormSection>
                    <FormRow>
                        <FormSectionTitle>
                            הודעה למשתמש על ריקוד שנדחה על ידי ההנהלה
                        </FormSectionTitle>
                    </FormRow>
                    <FormRow>
                        <TextInput
                            text={
                                newAppConfig
                                    ? newAppConfig.denied_application_mail_subject
                                    : ''
                            }
                            onChangeText={(denied_application_mail_subject) =>
                                setNewAppConfigProp({
                                    denied_application_mail_subject,
                                })
                            }
                            width={'initial'}
                            required={true}
                            label={'נושא ההודעה'}
                            hideRequiredSign
                        />
                    </FormRow>
                    <FormRow>
                        <TextAreaInput
                            text={
                                newAppConfig
                                    ? newAppConfig.denied_application_mail_body
                                    : ''
                            }
                            onChangeText={(denied_application_mail_body) =>
                                setNewAppConfigProp({
                                    denied_application_mail_body,
                                })
                            }
                            minHeight="200px"
                            placeholder="הקלד כאן"
                            label={'תוכן ההודעה'}
                            hideRequiredSign
                        />
                    </FormRow>
                </FormSection>

                <FormSection>
                    <FormRow>
                        <FormSectionTitle>
                            הודעה למשתמש שהריקוד הרשום עליו בקרוב יפוג
                        </FormSectionTitle>
                    </FormRow>
                    <FormRow>
                        <TextInput
                            text={
                                newAppConfig
                                    ? newAppConfig.song_application_near_to_expire_mail_subject
                                    : ''
                            }
                            onChangeText={(
                                song_application_near_to_expire_mail_subject
                            ) =>
                                setNewAppConfigProp({
                                    song_application_near_to_expire_mail_subject,
                                })
                            }
                            width={'initial'}
                            required={true}
                            label={'נושא ההודעה'}
                            hideRequiredSign
                        />
                    </FormRow>
                    <FormRow>
                        <TextAreaInput
                            text={
                                newAppConfig
                                    ? newAppConfig.song_application_near_to_expire_mail_body
                                    : ''
                            }
                            onChangeText={(
                                song_application_near_to_expire_mail_body
                            ) =>
                                setNewAppConfigProp({
                                    song_application_near_to_expire_mail_body,
                                })
                            }
                            minHeight="200px"
                            placeholder="הקלד כאן"
                            label={'תוכן ההודעה'}
                            hideRequiredSign
                        />
                    </FormRow>

                    <SubmitBtnContiner justifyContent={'center'}>
                        <SubmitBtn onClick={openSaveConfigsModal}>
                            שמירה
                        </SubmitBtn>
                    </SubmitBtnContiner>
                </FormSection>
            </FormWrapper>
        </GrayWrapper>
    )
}

const SubmitBtnContiner = styled(FormRow)`
    justify-content: center;
    margin: 32px 0 20px;
`
